/**
 * @typedef {Object} IncidentCreateDto
 * @property {string} requestType - 'INCIDENT' | 'SERVICE_REQUEST'
 * @property {string} title
 * @property {string} [description]
 * @property {string} [priority] - 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT'
 * @property {number} [stationId]
 * @property {number} [productionOrderId]
 * @property {number} [componentId]
 */

/**
 * @typedef {Object} IncidentResponseDto
 * @property {number} incidentId
 * @property {string} requestType
 * @property {string} title
 * @property {string} priority
 * @property {string} statusCode
 * @property {string} statusName
 * @property {string} reportedByName
 * @property {string} [assignedToName]
 */

const BASE_PATH = 'v1/Incident';

export default function (instance) {
  return {
    getIncidents(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    getIncident(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    createIncident(payload) {
      return instance.post(BASE_PATH, payload);
    },

    updateIncident(id, payload) {
      return instance.put(`${BASE_PATH}/${id}`, payload);
    },

    setIncidentStatus(id, payload) {
      return instance.put(`${BASE_PATH}/${id}/status`, payload);
    },

    deleteIncident(id) {
      return instance.delete(`${BASE_PATH}/${id}`);
    }
  };
}
